// Must stay the first import so errors during app start-up are reported.
import { Sentry } from './sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

function CrashFallback() {
  return (
    <div style={{ padding: '48px 16px', textAlign: 'center', fontFamily: 'sans-serif' }}>
      <h2>Something went wrong.</h2>
      <p>Reloading the page usually fixes it.</p>
      <button type="button" onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {/* Without a boundary a render crash leaves a blank page; this reports
        it to GlitchTip (when enabled) and offers a reload instead. */}
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
